import React, { useState } from "react";
import { Switch, Headings, Texts } from "retro";
import { Mail, Smartphone, CreditCard, CheckSquare } from "lucide-react";

function DemoRoute() {
  const [modules, setModules] = useState([
    {
      name: "Email",
      icon: <Mail size={40} color="#1e3a8a" />,
      type: "EMAIL",
      des: "All email communications going through your account appears here",
      enabled: true,
    },
    {
      name: "Whatsapp",
      icon: <Smartphone size={40} color="#059669" />,
      type: "WHATSAPP",
      des: "All WhatsApp communications going through your account appears here",
      enabled: false,
    },
    {
      name: "Mobile SMS",
      icon: <Smartphone size={40} color="#d97706" />,
      type: "SMS",
      des: "All SMS communications going through your account appears here",
      enabled: true,
    },
    {
      name: "VAT Validation",
      icon: <Smartphone size={40} color="#b91c1c" />,
      type: "VATVALID",
      des: "All VAT validation going through your account appears here",
      enabled: true,
    },
    {
      name: "WST Validation",
      icon: <Smartphone size={40} color="#b91c1c" />,
      type: "WSTVALID",
      des: "All WST validation going through your account appears here",
      enabled: true,
    },
    {
      name: "Expense OCR",
      icon: <CreditCard size={40} color="#2563eb" />,
      type: "EXPENSEOCR",
      des: "Enable or disable invoice module for this organisation",
      enabled: false,
    },
    {
      name: "Invoice OCR",
      icon: <CreditCard size={40} color="#9333ea" />,
      type: "INVOICEOCR",
      des: "Enable or disable QR payments module for this organisation",
      enabled: false,
    },
    {
      name: "Approval",
      icon: <CheckSquare size={40} color="#f59e0b" />,
      type: "APPROVAL",
      des: "Module for approvals and validation workflow",
      enabled: false,
    },
  ]);

  const toggleModule = (index) => {
    const newModules = [...modules];
    newModules[index].enabled = !newModules[index].enabled;
    setModules(newModules);
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: "16px",
      }}
    >
      {modules.map((item, index) => {
        const checked = item.enabled;
        return (
          <div
            key={item.type}
            className="retro-card"
            style={{
              position: "relative",
              padding: 24,
              minWidth: 350, // fallback for very small screens

            }}
          >
            {/* Toggle Switch */}
            <div
              style={{
                position: "absolute",
                right: 12,
                top: 12,
                zIndex: 2,
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <Switch
                state={checked}
                onChange={() => toggleModule(index)}
                size="large"
              />
            </div>

            {/* Module Icon and Info */}
            <div style={{ opacity: checked ? 1 : 0.37 }}>
              <div style={{ marginBottom: 12 }}>{item.icon}</div>
              <Headings.Regular margin="mt4">{item.name}</Headings.Regular>
              <Texts.Small
                style={{ maxLines: 2, display: "block", marginTop: 4 }}
              >
                {item.des}
              </Texts.Small>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default DemoRoute;
